import {
  isCurrentLocalSessionValid,
  getSession,
} from '@/unified-modules/account/account-library';
import { AW_COOKIE } from '@/utilities/constants/metadata';
import { clearSessionAndRedirectToLogin } from '@/utilities/helpers/clearSession';
import { CLEAR_SESSION_REASON } from '@/unified-modules/account/account-library';
import { AxiosInstance } from 'axios';
import { syncSessionToStore } from '@/unified-modules/account/annexes/session-manager';
import { Account } from '@fanduel/cpe-um-bundle/account/library';

export const sessionExpirationRequestInterceptor = (
  axiosInstance: AxiosInstance,
) => {
  const interceptor = axiosInstance.interceptors.response.use(
    (requestResponse) => requestResponse,
    async (requestError) => {
      const status = requestError?.response?.status;
      if (status !== 401) {
        return Promise.reject(requestError);
      }

      //  Checks session validity before retrying
      const validSession = await isCurrentLocalSessionValid();
      axiosInstance.interceptors.response.eject(interceptor);

      /**
       *  If session is valid try get details about session.
       *  If no session retrieved reject with requestError.
       */
      if (validSession) {
        const session = await getSession();

        if (!session) {
          return Promise.reject(requestError);
        }

        /**
         *  If retrieved AuthToken -> Set again on AxiosInstance and ReqeustError headers.
         *  Sync internal state and re-read Account UM-managed cookies.
         *  Return instance with errorRequest config (new token).
         */
        if (session) {
          syncSessionToStore();
          const authToken = session.token;

          if (!authToken) {
            return Promise.reject(requestError);
          }

          axiosInstance.defaults.headers[AW_COOKIE.AUTH_TOKEN] = authToken;
          requestError.response.config.headers[AW_COOKIE.AUTH_TOKEN] =
            authToken;
          const loginToken = await Account.getLoginTokenAsync();

          if (loginToken) {
            axiosInstance.defaults.headers[AW_COOKIE.LOGIN_TOKEN] = loginToken;
            requestError.response.config.headers[AW_COOKIE.LOGIN_TOKEN] =
              loginToken;
          }

          return axiosInstance(requestError.response.config);
        }
      }

      /**
       *  If the session is invalid
       *  Check if user had a session inside local storage -> Reset value
       *  Clear session(local and remote) -> redirect to login.
       */

      await clearSessionAndRedirectToLogin(
        CLEAR_SESSION_REASON.OTHER,
        undefined,
        true,
      );

      // Clear the session
      sessionExpirationRequestInterceptor(axiosInstance);
    },
  );
};
